import { ErrorData } from './error-data';
import { TabConfig } from './tab-config';
import { TabDisplayConfig } from './tab-display-config';
import { TableData } from './table-data';

export class TabData {
	public static create(options: TabDataOptions): TabData {
		return new TabData(options.config, options.tableData, options.displayConfig, options.error);
	}
	constructor(public readonly config: TabConfig, public tableData: TableData[] = [], public readonly displayConfig: TabDisplayConfig = null, public error?: ErrorData) { }

	public get id(): string {
		return this.config.id;
	}
}

export interface TabDataOptions {
	config: TabConfig;
	tableData: TableData[];
	displayConfig: TabDisplayConfig;
	error: ErrorData;
}
